import { IAppData } from 'client/common/types';

export function getAgencyPageProps(data: IAppData) {
    return data.agencyPage;
}
